module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Site_Footer Widget

(function (fox, $) {
  "use strict";
  var _ = {
    RABBIT_ACTIVE_STATE: 1,
    RABBIT_PENDING_STATE: 2,
  };

  fox.registerWidget(
    "Site_Footer",
    {
      configure: function (options) {
        this.counter = 0;

        this.registerOptions("", {
          aliases: [
            "2257",
            "editable",
            "billing",
            "copyright",
            "powered",
            "smallBannersContainer",
          ],
          "2257.template": "footer_2257",
          "editable.template": "footer_editable",
          "billing.template": "footer_billing",
          "powered.template": "footer_powered",
          "smallBannersContainer.template": "footer_b_wrapper",

          rabbitsReviewsBanner: {
            widget: "Widget",
            autoRender: true,
            embed: {
              container: ".b-list",
              location: "lastChild",
              widget: "@parent #smallBannersContainer",
            },
            template:
              'a[href="https://www.rabbitsreviews.com/$[link]" target="_blank" rel="nofollow"]>img[src="https://www.rabbitsreviews.com/images/banners/rabbitsreview_120x60.gif" alt="Rabbits Reviews" border=0]+br+span{Rabbits Porn Reviews}',
          },
          copyright: {
            template: "footer_copyright",
            widgets: {
              copyrightYears: {
                widget: "Copyright",
                template: "copyright",
              },
            },
          },

          handleDom: {
            goAccountPage: {
              targetWidget: "#editable",
              target: "#go-account-page",
              event: "click",
              callback: "_goToAccountPage",
            },
            reportSite: {
              targetWidget: "#editable",
              event: "click",
              target: "#_sesta",
              callback: function () {
                this.rwom1("@root .SestaFosta_Popup").show();
              },
            },
          },
        });
        this.registerOptions("#editable", {
          handleDom: {
            reportProblem: {
              event: "click",
              target: "#_reportProblem",
              callback: "@parent:reportProblem",
            },
            reportSite: {
              event: "click",
              target: "#_sesta",
              callback: function () {
                this.rwom1("@root .SestaFosta_Popup").show();
              },
            },

            // ,

            // goAccountPage: {
            // 	target: '#go-account-page',
            // 	event: 'click',
            // 	callback: "@parent:goToAccountPage"
            //					}
          },
        });

        if (options.infinityFooter) {
          this.registerOptions(".Widget", {
            "handleWom.addedToDom": {
              widget: "@this",
              event: "addedToDom",
              callback: "@parent:_handleWidgetsRenderring",
            },
          });
        }

        this.callParent("configure", arguments);
      },

      init: function () {
        var container;
        var copyright = {};
        var rabbitOpts = this.getOption("rabbitsReviewsBanner");
        var rabbitState = Number(fox.getEnv("rabbitsReviewsStatus"));

        this._aliases = this.getOption("aliases");

        container = this.requireOption("container");

        fox.each(
          this._aliases,
          function (alias) {
            var cont = this.getOption(alias + ".container");

            this.embedWidget(
              alias,
              "Widget",
              fox.mergeRecursive(
                {
                  autoRender: true,
                  embed: {
                    location: "lastChild",
                    container: cont || container,
                  },
                  "templateOptions.affiliateLink": this.generateAffiliateLink(),
                },
                this.getOption(alias)
              )
            );
          },
          this
        );

        if (
          fox.inArray(
            [_.RABBIT_ACTIVE_STATE, _.RABBIT_PENDING_STATE],
            rabbitState
          )
        ) {
          var link =
            fox.getEnv("rabbitsReviewsCategory") !== "21"
              ? "Default.aspx"
              : "c21/Gay.html";

          if (fox._isNewfe) {
            rabbitOpts.template = rabbitOpts.template.replace("$[link]", link);
          } //else {
          // rabbitOpts.templateOptions = {
          // 	link
          // };
          //}

          this.embedWidget(
            "rabbitsReviewsBanner",
            rabbitOpts.widget,
            rabbitOpts
          );
        }

        this.callParent("init", arguments);
      },

      deactivate: function (argument) {
        this.counter = 0;

        this.callParent("deactivate", arguments);
      },

      reportProblem: function () {
        var user, form;

        user = fox.site.member ? fox.site.member.getObjectValue("id") : "";
        form = $("<form>").attr({
          target: "_blank",
          method: "GET",
          action: "https://support.modelcentro.com/hc/en-us/requests/new",
        });

        $("<input>")
          .attr({
            type: "hidden",
            name: "ticket_form_id",
            value: "10328880669981",
          })
          .appendTo(form);

        form.appendTo("body").submit();
      },

      _goToAccountPage: function () {
        this.hookWrapper("goToAccountPage");
      },

      _getWidgetsCount: function (argument) {
        return this.wom(".Widget").length;
      },

      _handleWidgetsRenderring: function (obj, w, e) {
        this.counter++;

        if (this.counter === this._getWidgetsCount()) {
          this.dispatchEvent("allWidgetsInDom");
          return;
        }
      },

      generateAffiliateLink: function () {
        var url = "";
        var whiteLabelDomain = fox.getEnv("wlDomain");

        if (fox.getEnv("affiliateArea")) {
          url = "https://centroprofits.com";
        }

        if (whiteLabelDomain) {
          url = "http://" + whiteLabelDomain;
        }

        return url;
      },
    },
    "Controller"
  );
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/footer.js
// module id = 868
// module chunks = 4